import './style.scss';
import React, { useState } from 'react';
import EligibleCardComponent from '../EligibleCardComponent';
import TabsCarouselComponent from '../Tabs/shared/carousel/TabsCarouselComponent';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const EligibleCardsComponent = (props) => {
  const context = useSitecoreContext();
  const { eligibleCards, excludedCards } = context?.sitecoreContext?.route?.fields;
  const tabsTitles = tabs?.fields?.items;
  const tabsTitlesLength = tabsTitles?.length; //only show if we have at least one tab, they are max 2 tabs and static
  const getTabName = (item) => item?.name || '';
  const firstTabName = { id: getTabName(tabsTitles?.[0]), name: getTabName(tabsTitles?.[0]) };
  const [activeTabName, setActiveTabName] = useState(firstTabName);
  const [cardItems, setCardItems] = useState(eligibleCards);
  const shouldContinue =
    (!!eligibleCards && eligibleCards?.length > 0) || (!!excludedCards && excludedCards.length > 0);
  if (!shouldContinue) {
    return null;
  }
  //translation
  const { t: translate, params } = props;
  const eligibleCardsTabtitle = translate('OfferDetail_EligibleCardsSectionTitle');
  const OfferDetail_EligibleCards = translate('OfferDetail_EligibleCards');
  const OfferDetail_ExcludedCards = translate('OfferDetail_ExcludedCards');

  let tabs = {
    fields: {
      items: [],
    },
  };

  if (!!eligibleCards && eligibleCards?.length > 0) {
    tabs.fields.items.push({
      name: OfferDetail_EligibleCards,
      id: OfferDetail_EligibleCards,
    });
  }
  if (!!excludedCards && excludedCards.length > 0) {
    tabs.fields.items.push({
      name: OfferDetail_ExcludedCards,
      id: OfferDetail_ExcludedCards,
    });
  }
  const shouldRenderCards = !!cardItems && cardItems.length > 0;
  //methods
  const showData = (tab) => {
    if (tab?.name === OfferDetail_ExcludedCards) {
      setCardItems(excludedCards);
    } else {
      setCardItems(eligibleCards);
    }
  };

  return (
    tabsTitlesLength > 0 && (
      <div className={clsx('eligible-card-items content', 'add-margins', params?.Styles)}>
        <div className="main-title">{eligibleCardsTabtitle}</div>
        <TabsCarouselComponent
          onTabClick={(name) => {
            setActiveTabName({ id: name, name: name });
            showData(name);
          }}
          initialTabName={activeTabName}
          tabNames={tabsTitles?.map((item) => ({ id: getTabName(item), name: getTabName(item) }))}
          className="tabs-component-pc"
          lang={props.i18n.language}
        />
        {shouldRenderCards && (
          <div className="items flex-it flex-wrap">
            {cardItems?.map((card, iCard) => {
              return <EligibleCardComponent card={card} key={iCard} />;
            })}
          </div>
        )}
      </div>
    )
  );
};
export default withTranslation()(EligibleCardsComponent);
